import _ from 'lodash'
import moment from 'moment'
import * as crypto from 'crypto'
import axios from 'axios'

export function replaceTagHtml(
  html: string,
  columns: { [key: string]: string },
) {
  if (columns) {
    const key = _.keys(columns)
    key.forEach((e) => {
      html = _.replace(html, `[${e}]`, columns[e])
      html = _.replace(html, `[#${e}#]`, columns[e])
    })
  }
  return html
}

export function telPhone(phone: string) {
  window.open('tel:' + phone)
}

export function getTime(timestamp: number) {
  return moment.unix(timestamp).format('HH:mm')
}

export function getFullDate(timestamp: number) {
  return moment.unix(timestamp).format('DD-MM-YYYY HH:mm:ss')
}

export function mapTypeToIcon(type: string) {
  if (type.search('Create') !== -1) {
    return 'mdi-plus-circle-outline'
  } else if (type.search('Delete') !== -1 ) {
    return 'mdi-delete'
  } else if (type.search('Login') !== -1) {
    return 'mdi-comment-account-outline'
  } else if (type.search('Change Password') !== -1) {
    return 'mdi-autorenew'
  } else if (type.search('Update User') !== -1) {
    return 'mdi-update'
  } else if (type.search('Send') !== -1) {
    return 'mdi-send'
  } else if (type.search('Update') !== -1 ) {
    return 'mdi-pencil'
  } else if (type.search('Purchase') !== -1 ) {
    return 'mdi-cart-outline'
  } else {
    return 'mdi-bell-ring'
  }
}

export function hashFunction(inputText: string) {
  const hashcrypto = crypto.createHmac('sha256', process.env.HASHKEY || '')
  return hashcrypto.update(inputText, 'utf8').digest('base64')
}

export function validateResetPasswordToken(token: string) {
  try {
    return axios.get(
      process.env.VUE_APP_BASEURL + '/v2/authentication/resetpassword/' + token,
    )
  } catch (error) {
    console.error(error)
  }
}

// This function return <a> tag
// You have to use .click() function manually

export async function changeBlobInToCSVFile(blobData: any, fileName: string) {
  try {
    const fileURL = window.URL.createObjectURL(new Blob([blobData]))
    const fileLink = document.createElement('a')
    fileLink.href = fileURL
    fileLink.setAttribute('download', fileName + '.csv')
    document.body.appendChild(fileLink)
    fileLink.click()
    document.removeChild(fileLink)
  } catch (error) {
    console.log(error)
    throw error
  }
}
/**
 * @param email: example@mail.com
 * @returns e*****e@n***.com
 */
export function maskingEmail(email: string) {
  const regex: RegExp = new RegExp(/(.)(.*?)(.@.)(.*?)(\.[^\.]+)$/g)
  const match: RegExpExecArray | null = regex.exec(email)
  const firstChar: string = match![1]
  const emailName: string = match![2]
  const emailSymbol: string = match![3]
  const domain: string = match![4]
  const dotCom: string = match![5]

  return (
    firstChar +
    '*'.repeat(emailName.length) +
    emailSymbol +
    '*'.repeat(domain.length) +
    dotCom
  )
}

export function maskingPhone(phone: string): string {
  const phoneLen: number = phone.length
  const masking: string = '*'.repeat(phoneLen - 4)
  return (
    phone[0] + phone[1] + masking + phone[phoneLen - 2] + phone[phoneLen - 1]
  )
}

export function isObject<T>(value: object | string | number | (() => object) | T[]): boolean {
  return typeof value === 'object' && value !== null
}

export function extactObjByWord(
  objectTarget: object, word: string,
): object {
  const dataByWord = {}
  for (const key in objectTarget) {
    if (key.includes(word)) {
      dataByWord[key] = objectTarget[key]
    }
  }
  return dataByWord
}
